module.exports = __webpack_public_path__ + "static/media/more.cd3483c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/more.svg
// module id = 473
// module chunks = 0